// Core
import { handleActions } from 'redux-actions';
import { Map } from 'immutable';

const initialState = Map({
    otpusk: Map({
        token:  { 'access_token': '2716a-a6aa2-8ce60-439c2-641a5' },
        demo:   { 'access_token': '2267d-e686d-6322b-4d3e4-1b87a' },
        office: 1299,
    }),
    user: Map({
        authenticated: true,
    }),
});

export const authReducer = handleActions({}, initialState);
